import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "31",
  viewBox: "0 0 30 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "15.5",
      r: "15",
      fill: "#8759D7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.16602 15.4997C9.16602 15.0394 9.53911 14.6663 9.99935 14.6663H19.9993C20.4596 14.6663 20.8327 15.0394 20.8327 15.4997V21.333C20.8327 21.7932 20.4596 22.1663 19.9993 22.1663H9.99935C9.53911 22.1663 9.16602 21.7932 9.16602 21.333V15.4997Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.9993 10.4997C13.6186 10.4997 12.4993 11.619 12.4993 12.9997V16.333H10.8327V12.9997C10.8327 10.6985 12.6982 8.83301 14.9993 8.83301C17.3005 8.83301 19.166 10.6985 19.166 12.9997V16.333H17.4993V12.9997C17.4993 11.619 16.3801 10.4997 14.9993 10.4997Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }